import { Space } from "antd";
import { Button } from "../../modules/button";

interface ButtonListProps {
  items: any[];
}

export const ButtonList = (props: Partial<ButtonListProps>) => {
  const { items = [] } = props;

  return (
    <Space>
      {items.map(
        ({ hidden = false, ...restButtonProps }, index) =>
          !hidden && <Button key={index} {...restButtonProps} />
      )}
    </Space>
  );
};
